import { MdCheck } from 'react-icons/md';
import { useEffect } from 'react';
import { ReportingControllerBaseConfig } from '../../../../../base';
import { NumberElementController } from './numberElementInterface';
import { NumberElementViewProps } from './numberElementProps';

export function createNumberElementController(
    config: ReportingControllerBaseConfig
): NumberElementController {
    return {
        useProps(props): NumberElementViewProps {
            return {
                containerRef: props.containerRef,
                isEmpty: props.field.value === null,
                edit: {
                    value: props.isEditing,
                    button: {
                        onClick() {
                            props.onEdit();
                        },
                    },
                },
                submit: {
                    label: 'Save',
                    Icon: MdCheck,
                    button: {
                        isDisabled: !props.field.isDirty,
                        onClick() {
                            props.onSubmit(props.field.value);
                        },
                        // NOTE Need to prevent mouse down event event from trigger blur handler
                        onMouseDown(event) {
                            event.preventDefault();
                        },
                    },
                },
                label: props.field.value?.toString() ?? 'Empty',
                input: {
                    onKeyDown(event) {
                        if (event.key === 'Enter' && props.isEditing) {
                            props.onSubmit(props.field.value);
                            event.preventDefault();
                            event.stopPropagation();
                        }
                        if (event.key === 'Escape' && props.isEditing) {
                            props.onCancel();
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    },
                    value: props.field.value ?? '',
                    onChange(_valueAsString, valueAsNumber) {
                        if (valueAsNumber === null || isNaN(valueAsNumber)) {
                            props.field.onChange(null);
                            return;
                        }
                        props.field.onChange(valueAsNumber);
                    },
                    onBlur(_event) {
                        props.onBlur();
                    },
                },
            };
        },
    };
}
